(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-wishlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function getKey() {
    var cid = window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
              window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId;
    return cid ? 'gng_wishlist_' + cid : 'gng_wishlist_guest';
  }

  function getHandles() {
    try { return JSON.parse(localStorage.getItem(getKey())) || []; }
    catch (e) { return []; }
  }

  function removeHandle(handle) {
    var items = getHandles().filter(function (h) { return h !== handle; });
    localStorage.setItem(getKey(), JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('gng:wishlist:change', { detail: { handles: items, count: items.length } }));
  }

  function fmt(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function renderCard(product) {
    var variant = product.variants[0];
    var img = product.featured_image
      ? product.featured_image.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png').replace('.webp', '_300x.webp')
      : null;

    var card = document.createElement('article');
    card.className = 'product-card wishlist-card';
    card.setAttribute('data-handle', product.handle);
    card.innerHTML = [
      '<a href="/products/' + product.handle + '" class="product-card-media" aria-label="' + product.title.replace(/"/g, '&quot;') + '">',
        img
          ? '<img src="' + img + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300">'
          : '<div class="wishlist-img-placeholder"></div>',
      '</a>',
      '<button type="button" class="wishlist-btn active wishlist-remove-btn" data-handle="' + product.handle + '" aria-label="Aus Merkliste entfernen">',
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">',
          '<path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>',
        '</svg>',
      '</button>',
      '<div class="product-card-body">',
        product.vendor ? '<div class="product-card-brand">' + product.vendor + '</div>' : '',
        '<a href="/products/' + product.handle + '" class="product-card-title-link">',
          '<div class="product-card-title">' + product.title + '</div>',
        '</a>',
        variant && variant.price
          ? '<div class="product-card-price-row"><span class="product-card-price">' + fmt(variant.price) + '</span></div>'
          : '',
        variant && variant.available
          ? [
              '<div class="product-card-qty-row">',
                '<div class="qty-control">',
                  '<button type="button" class="qty-btn" data-qty-dec aria-label="Weniger">−</button>',
                  '<input type="number" id="wqty-' + variant.id + '" class="qty-input" value="1" min="1" max="999" aria-label="Menge">',
                  '<button type="button" class="qty-btn" data-qty-inc aria-label="Mehr">+</button>',
                '</div>',
                '<button type="button" class="product-card-add product-card-add--cart" data-add-to-cart data-variant-id="' + variant.id + '" data-qty-input="wqty-' + variant.id + '" data-title="' + product.title.replace(/"/g, '&quot;') + '" aria-label="In den Warenkorb">',
                  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>',
                '</button>',
              '</div>',
            ].join('')
          : '<button type="button" class="product-card-add product-card-add--disabled" disabled>Ausverkauft</button>',
      '</div>',
    ].join('');

    card.querySelector('.wishlist-remove-btn').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      removeHandle(product.handle);
      card.style.opacity = '0';
      card.style.transform = 'scale(0.95)';
      card.style.transition = 'opacity 0.2s, transform 0.2s';
      setTimeout(function () { card.remove(); checkEmpty(); }, 220);
    });

    return card;
  }

  function checkEmpty() {
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    var label = document.getElementById('wishlist-count-label');
    var count = grid ? grid.children.length : 0;
    if (label) label.textContent = count > 0 ? count + ' Artikel' : '';
    if (empty && grid) {
      if (count === 0) { empty.style.display = 'flex'; grid.style.display = 'none'; }
      else { empty.style.display = 'none'; grid.style.display = 'grid'; }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var handles = getHandles();
    var grid = document.getElementById('wishlist-grid');
    var loading = document.getElementById('wishlist-loading');
    var empty = document.getElementById('wishlist-empty');

    if (!grid) return;

    if (handles.length === 0) {
      loading.style.display = 'none';
      empty.style.display = 'flex';
      return;
    }

    var loaded = 0;
    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          grid.appendChild(renderCard(product));
        })
        .catch(function () { /* product not found, skip */ })
        .finally(function () {
          loaded++;
          if (loaded === handles.length) {
            loading.style.display = 'none';
            checkEmpty();
          }
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
